import React, {useState} from 'react';
import Icon from '../Icons/Icon';
import Loading from '../Loading';
import { classNames, useNewWindow } from '../../Services/helpers';
import { useNavigate } from 'react-router-dom';
import {themes, bgs, sizes, selectedThemes} from './settings';
import { useOffline } from '../Offline';

const Button = ({label, type, theme, selected, icon, emoji, iconTheme, className, onClick, onClickLoading, link, disabled, loading, zeroMargin, hide, badge, iconBadge, noShadow, size = "md", availableOffline = false}) => {
    const navigate = useNavigate();
    const newWindow = useNewWindow();
    const {isOnline, offlineSupported} = useOffline();
    const [onClickAutoLoading, setOnClickAutoLoading] = useState(false);

    const offlineUnavailable = !(availableOffline && offlineSupported) && !isOnline;

    if (hide) {
        return null;
    }

    return <button
        type={type ?? 'button'}
        // className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-500 sm:ml-3 sm:w-auto"
        className={classNames(
            className,
            !selected && themes[theme],
            selected && (selectedThemes[theme] ?? null),
            !zeroMargin && 'my-3',
            'rounded-lg font-semibold shrink-0',
            sizes[size].classes,
            noShadow && 'shadow-none',
            // Clashes with the above classes from settings, but it works..
            // Fixes the look of buttons in the navbar
            zeroMargin && icon && !label && 'pb-1',
        )}
        disabled={disabled || loading || onClickAutoLoading || offlineUnavailable}
        onClick={(e) => {
            if (type !== 'submit') {
                e.preventDefault();
                e.stopPropagation();
            }
            if (link) {
                if (link.startsWith('http') && link.indexOf('app.getsoapy') === -1) {
                    newWindow(link);
                } else {
                    navigate(link);
                }
            }
            e.currentTarget.blur();

            if (onClick) {
                if (onClickLoading) {
                    setOnClickAutoLoading(true);
                }
                const promise = onClick();
                if (onClickLoading) {
                    Promise.resolve(promise).finally(() => setOnClickAutoLoading(false));
                }
            }
        }}
    >
        {(icon && !(loading || onClickAutoLoading)) &&  <Icon icon={icon}
            theme={iconTheme}
            size={sizes[size].iconSize}
            aria-hidden="true"
            className={classNames(label && 'mr-2')}
            inline
            iconBadge={iconBadge}
        />}

        {(emoji && !(loading || onClickAutoLoading)) &&  <span className={label ? 'mr-2' : ''}>{emoji}</span>}

        {(loading || onClickAutoLoading) && <Loading size="1x" className="mr-2" inline bg={bgs[theme]} />}

        {label}

        {(badge === true || parseInt(badge) > 0) && <Badge badge={badge} />}
    </button>
}

const Badge = ({badge}) => {
    return <span className='ml-2 rounded-full bg-red-600 text-white px-2 text-xs'>
        {badge === true ? <>&#9679;</> : badge}
    </span>
}

export default Button;
